import { dateDiffHumanReadable } from "@/filters/DateAndTime";
import { patientNamespace } from "@/store/modules/patient";
import { BodyData } from "@/store/modules/patient/types";
import { Atom } from "@/store/types";
import _ from "lodash";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { Colors, tryParseJSON } from "../shared/util";

enum SepsisState {
  Passed,
  BeforeAlert,
  AfterAlert,
  Missed,
  NA
}
const stateToConfigLookup: Array<{ text: string; color: Colors }> = [
  { text: "Passed", color: Colors.Green },
  { text: "1+ hr left", color: Colors.Yellow },
  { text: "<1 hr left", color: Colors.Orange },
  { text: "Missed", color: Colors.Red },
  { text: "N/A", color: Colors.Gray }
];

export const SEPSIS_ORDER = [
  "Blood Culture",
  "Antibiotic",
  "First Lactate",
  "Second Lactate",
  "Culture B4 Antibiotic"
];
@Component({})
export default class ListSepsis extends Vue {
  @Getter("now", patientNamespace)
  now: any;

  @Prop(Object)
  data!: BodyData;

  get bpaTime() {
    const sepsisAtom = _.get(this.data, "atoms.sepsis") as Atom;
    if (sepsisAtom && sepsisAtom.age > -1) {
      return dateDiffHumanReadable(sepsisAtom.time, this.now);
    } else {
      return "N/A";
    }
  }

  get sepsisStates() {
    const rawSepsisData = _.get(this.data, "atoms.sepsis.legend");
    const sepsisData = tryParseJSON(rawSepsisData, []);
    const mappedData = SEPSIS_ORDER.map((key: string) => {
      const value = sepsisData[key];
      if (value) {
        return stateToConfigLookup[value.State];
      } else {
        return stateToConfigLookup[SepsisState.NA];
      }
    });

    return mappedData;
  }
}
